<template>
  <div class="w-full">
    <div v-if="!uploading" class="flex flex-col gap-2">
      <label
        class="w-full py-3 px-4 inline-flex items-center justify-center gap-2 text-sm font-medium tracking-wide rounded-lg bg-gray-700 text-white hover:bg-gray-800 cursor-pointer transition-colors"
      >
        <unicon name="camera" class="w-4 h-4" fill="currentColor" />
        Add Photo
        <input
          type="file"
          accept="image/*"
          class="hidden"
          @change="handleFile"
        />
      </label>
    </div>
    <div v-else class="text-sm text-gray-500 py-2 text-center">Uploading…</div>
  </div>
</template>

<script>
import { storage } from '@/firebase'
import { newId } from '@/utils'

export default {
  name: 'CameraCapture',
  props: {
    isDeveloperOrAdmin: { type: Boolean, default: false }
  },
  data() {
    return { uploading: false }
  },
  methods: {
    async handleFile(event) {
      const file = event.target.files[0]
      if (!file) return
      this.uploading = true
      const id = newId()
      try {
        const ref = storage.ref(`images/${id}`)
        await ref.put(file, { contentType: file.type })
        const downloadURL = await ref.getDownloadURL()
        this.$emit('captured', downloadURL)
      } catch (e) {
        console.error('Upload failed:', e)
      } finally {
        this.uploading = false
        event.target.value = ''
      }
    }
  }
}
</script>
